import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Expand: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M16.7 21.7a1 1 0 0 1-1.4 0l-10-10a1 1 0 1 1 1.4-1.4l9.3 9.3 9.3-9.3a1 1 0 1 1 1.4 1.4l-10 10Z"
    />
  </Icon>
);
